module.exports = __webpack_public_path__ + "img/google_playstore.aeae6174.png";